import 'trimmings'

window.$ = window.jQuery = $

import 'popper.js/dist/umd/popper'
import 'bootstrap/dist/js/bootstrap'
import 'frontend_controllers'
import 'ahoy-cross-domain-tracking'
import 'form-request-submit-polyfill'